// extracted by mini-css-extract-plugin
module.exports = {"cartBg":"Shipping_cartBg__3szgE","cartAndSummaryContainer":"Shipping_cartAndSummaryContainer__iqdbO"};